import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { ProfileService } from '../profile/profile.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'wifm-upload',
  templateUrl: './wifmupload.component.html',
  styleUrls: ['wifmupload.component.scss']
})
export class WifmUploadComponent implements OnInit {
  public isAuthenticated: boolean = false;
  public q: string;
  public files: File[] = [];
  public timer: number;
  @ViewChild('dropzone', { static: false }) dropZone: ElementRef;
  @ViewChild('fileBtn', { static: false }) fileBtn: ElementRef;
  public busySave: boolean = false;
  // public busyCamps: boolean = false;
  // public camps: Camp[] = [];
  // public campId: string;
  public fileNames: string[] = [];
  public fileNamesX: string[] = [];


  constructor(private authorizeService: AuthorizeService,
    private http: HttpClient, private router: Router, private route: ActivatedRoute,
    private profileSvc: ProfileService, private sanitizer: DomSanitizer,
    private authSvc: AuthorizeService) {
    this.authorizeService.isAuthenticated().subscribe(async bFlag => {
      if (!bFlag) this.router.navigate(['/home']);
      this.isAuthenticated = bFlag;

      var token = await this.authSvc.getToken();
      if (token.sub != "acfc2497-cb44-4394-b866-3f546b306ff6"
        && token.sub != '074e9283-ff17-49c1-b6f8-787d11dad581'
        && token.sub != 'ff08b278-700d-4d51-a589-42034ab6c925' // Steve Cohn
      ) this.router.navigate(['/home']);
    });
  }

  ngOnInit(): void {
  }

  public selectFile(evt: any) {
    this.fileBtn.nativeElement.click();
  }
  public selectFileSubmit(evt: any) {
    this.files = evt.target.files
  }

  public async onDrop2(evt: any) {
    evt.preventDefault();
    this.files.length = 0;
    // we MUST prevent default here for drag/drop to work
    for (const item of evt.dataTransfer.items) {
      // kind will be 'file' for file/directory entries.
      if (item.kind === "file") {
        const entry = await item.getAsFileSystemHandle();
        if (entry.kind === "file") {
          console.log('got file')
          // run code for if entry is a file
        } else if (entry.kind === "directory") {
          // run code for is entry is a directory
          console.log('got directory')
          await this.iterateDirectory(entry, entry.name);

        }
      }
    }

    this.dropZone.nativeElement.classList.remove('myhover');
  }

  private async iterateDirectory(dirHandle, path) {
    for await (let handle of dirHandle.values()) {
      if (handle.kind == 'file') {
        console.log('handle=', path, handle);
        let f = await handle.getFile();
        this.files.push(f);
      }

      if (handle.kind == 'directory') {
        path += `~${handle.name}`;
        await this.iterateDirectory(handle, path);
      }
    }

  }

  public onDragOver2(evt: any) {
    // we MUST prevent default here for drag/drop to work
    evt.preventDefault();
  }

  public onDragEnter(evt: any) {
    evt.preventDefault();
    // the settimeout fixes the bug when user hovers over the span, we lose the 'hover' class
    setTimeout(() => this.dropZone.nativeElement.classList.add('myhover'), 1);

  }
  public onDragLeave(evt: any) {
    evt.preventDefault();
    this.dropZone.nativeElement.classList.remove('myhover');
  }

  // no idea why MAP doesn't work here on the file array... but it's not an array, it's an object?!?!
  public getFileNames() {
    let names: string[] = [];
    for (let f of this.files) names.push(f.name);
    return names.join(', ');
  }

  public getTimer() {
    if (this.timer == null) return null;
    const minutes = Math.floor(this.timer / 60);
    const seconds = this.timer % 60;

    return `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
  }

  // public loadingFiles: boolean = false;
  // public loadFiles() {
  //   this.loadingFiles = true;
  //   this.http.get<string[]>(`/api/adminupload/filelist`)
  //     .pipe(finalize(() => { this.loadingFiles = false; }))
  //     .subscribe(
  //       (resp: string[]) => {

  //         this.fileNames = resp;
  //         if (this.uploadMsg) {
  //           this.fileNamesX.length = 0;
  //           for (let f of this.files) { this.fileNamesX.push(f.name) }
  //           for (let f of this.fileNames) {
  //             let i = this.fileNamesX.findIndex(a => `/${a}` == f);
  //             if (i > -1) this.fileNamesX.splice(i, 1);
  //           }
  //           if (this.fileNamesX.length == 0) this.uploadMsg = " You can now close this window.";
  //         }

  //         setTimeout(() => this.loadFiles(), 5000);
  //       },
  //       (err) => { }
  //     )
  // }

  public uploadMsg: string;
  public submit(evt: any) {
    this.busySave = true;
    this.uploadMsg = " Please wait until the files finish upload before closing this page.";
    evt.preventDefault();
    const dStart = new Date();
    let intervalId = setInterval(() => {
      this.timer = Math.floor(((new Date().getTime() - dStart.getTime()) / 1000));
    }, 1000);

    const formData = new FormData();
    for (let [i, f] of this.files.entries()) {
      formData.append("file", f, f.name);
      formData.append("dir", `foo/bar/${i}`);
    }

    // Make http post request over api
    // with formData as req
    this.http.post(`/wifm/upload`, formData)
      .pipe(finalize(() => { clearInterval(intervalId); intervalId = null; this.timer = null; this.busySave = false; }))
      .subscribe(
        (resp) => { },
        (err) => { alert(`upload failed: ${err}`); }
      )
  }
}


